import { render, staticRenderFns } from "./ZahnwerkstattPatientsPage.vue?vue&type=template&id=dbaae968&scoped=true"
import script from "./ZahnwerkstattPatientsPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattPatientsPage.vue?vue&type=script&lang=js"
import style0 from "./ZahnwerkstattPatientsPage.vue?vue&type=style&index=0&id=dbaae968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaae968",
  null
  
)

export default component.exports